import Api from '../api/TeachingCard'
import { reactive } from 'vue';

const state = reactive({
    loading: false,
    exporting: true,
    lessons: [],
    elements: [],
    modules: [],
    currentClass: {},
    detailed: false,
    is_generating_export: false,
    is_lesson_history: false,
    is_app: false,
    show: {
        tsk: false,
        tree: false,
    },
    auth: '',
    error_message: '',
});

function init(isLessonHistory, isApp, auth) {
    state.is_lesson_history = isLessonHistory;
    state.is_app = isApp;
    state.auth = auth;
    state.loading = true;
    Api.Get().then(res => {
        state.loading = false;

        if (!res.success) {
            state.error_message = res.message;
            return;
        }

        state.lessons = res.data.lessons;
        state.elements = res.data.tc_elements;
        state.modules = res.data.modules;
        state.currentClass = res.data.current_class;
        state.detailed = res.data.detailed_view;
        state.show = res.data.show;
    })
}

function getElements() {
    return state.elements;
}

function getModules() {
    return state.modules;
}

function getClassShortName() {
    return state.currentClass.class_short_name;
}

function getLessons() {
    return state.lessons;
}

function showTSK() {
    return state.show.tsk;
}

function showTree() {
    return state.show.tree;
}

function displayDetailed() {
    return state.detailed;
}

function isExporting() {
    return state.exporting;
}

function isGeneratingExport() {
    return state.is_generating_export;
}

function isSelectedForExport(calendar_id) {
    return state.lessons.find(lesson => lesson.calendar_id === calendar_id).exporting;
}

function isLoading() {
    return state.loading;
}

function isFutureEvent(calendar_id) {
    return state.lessons.find(lesson => lesson.calendar_id === calendar_id).is_future_event;
}

function isLessonHistory() {
    return state.is_lesson_history;
}

function getErrorMessage() {
    return state.error_message;
}

function toggleExport() {
    state.exporting = !state.exporting;
    if (!state.exporting) {
        state.lessons = state.lessons.map(lesson => {
            lesson.exporting = false;
            return lesson;
        });
    }
}

function toggleExportLesson(calendar_id) {
    state.lessons = state.lessons.map(lesson => {
        if (lesson.calendar_id === calendar_id) {
            lesson.exporting = !lesson.exporting;
        }
        return lesson;
    });
}

function getStudentClassId() {
    return state.currentClass.student_class_id || null
}

function runExport() {
    state.is_generating_export = true;

    let calendar_ids = state.lessons.filter(lesson => lesson.exporting).map(lesson => lesson.calendar_id);
    window.location = '/lesson-history/export/' + state.currentClass.student_class_id + '?calendar_ids=' + calendar_ids.join(',') + (state.is_app ? '&auth=' + state.auth : '');
    window.setTimeout(() => {
        state.is_generating_export = false;
    }, 2000);
}

export default {
    state,
    init,
    getElements,
    getModules,
    getClassShortName,
    getLessons,
    showTSK,
    showTree,
    displayDetailed,
    isExporting,
    isGeneratingExport,
    isSelectedForExport,
    isLoading,
    isFutureEvent,
    isLessonHistory,
    getErrorMessage,
    getStudentClassId,
    toggleExportLesson,
    runExport
}
